import { getData } from '../generic';
import { cAPI } from '../../../utils/cAPI';

export const getNumberOfVisits = (searchConfig) => dispatch => getData(dispatch, cAPI.APGetNumberOfVisits, searchConfig);
export const getFrequentPhrases = searchConfig => dispatch => getData(dispatch, cAPI.APGetFrequentPhrases, searchConfig);
export const getLastPhrases = searchConfig => dispatch => getData(dispatch, cAPI.APGetLastPhrases, searchConfig);
export const getMostViewedProducts = searchConfig => dispatch => getData(dispatch, cAPI.APGetMostViewedProducts, searchConfig);